module.exports = require("npm:xtend@4.0.1/immutable");